import { paperClasses } from "@mui/material/Paper";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiCard = {
	defaultProps: {
		elevation: 6,
	},
	styleOverrides: {
		root: ({ theme }) => {
			const isDark = theme.palette.mode === "dark";
			return {
				borderRadius: theme.spacing(1.5),
				border: "none",
				boxShadow: isDark
					? "0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 1px 2px 0 rgba(0, 0, 0, 0.2)"
					: "0 1px 3px 0 rgba(0, 0, 0, 0.08), 0 1px 2px 0 rgba(0, 0, 0, 0.04)",
				[`&.${paperClasses.elevation1}`]: {
					boxShadow: isDark
						? "0 4px 16px 0 rgba(0, 0, 0, 0.32), 0 1px 4px 0 rgba(0, 0, 0, 0.2)"
						: "0 4px 16px 0 rgba(0, 0, 0, 0.06), 0 1px 4px 0 rgba(0, 0, 0, 0.04)",
				},
			};
		},
	},
} satisfies Components<Theme>["MuiCard"];
